import React from "react";

const Remove = () => {
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M20.4853 20.4853C15.799 25.1716 8.20101 25.1716 3.51472 20.4853C-1.17157 15.799 -1.17157 8.20101 3.51472 3.51472C8.20101 -1.17157 15.799 -1.17157 20.4853 3.51472C25.1716 8.20101 25.1716 15.799 20.4853 20.4853ZM16.0305 7.96949C16.382 8.32096 16.382 8.89081 16.0305 9.24228L13.2728 12L16.0305 14.7577C16.382 15.1092 16.382 15.679 16.0305 16.0305C15.679 16.382 15.1092 16.382 14.7577 16.0305L12 13.2728L9.24228 16.0305C8.89081 16.382 8.32096 16.382 7.96949 16.0305C7.61802 15.679 7.61802 15.1092 7.96949 14.7577L10.7272 12L7.96949 9.24228C7.61802 8.89081 7.61802 8.32096 7.96949 7.96949C8.32096 7.61802 8.89081 7.61802 9.24228 7.96949L12 10.7272L14.7577 7.96949C15.1092 7.61802 15.679 7.61802 16.0305 7.96949Z"
                fill="#0C002C"
            />
        </svg>
    );
};

export default Remove;
